export default __webpack_public_path__ + "static/media/1_0060.8eff2de1.webp";